import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";

const RulesContent = () => {
  return (
    <Box mt={10} mb={10} px={2} textAlign="left">
      <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
        Birds of Paradise – nyereményjáték szabályzat (2025)
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A Játék szervezője
      </Typography>
      <Typography variant="body1" paragraph>
        A születésnapi nyereményjáték (a továbbiakban ‘Játék’) szervezője a
        Birds of Paradise Kft. (székhely: 1015 Budapest, Batthyány utca 48. 4.
        em. 7., cégjegyzékszáma: 01-09-378875), a továbbiakban ‘Szervező’.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A Játék lebonyolítója
      </Typography>
      <Typography variant="body1" paragraph>
        A Játék megbízott lebonyolítója a Green Edge Media Group Kft. (székhely:
        1141 Budapest, Szugló utca 82.) a továbbiakban ‘Lebonyolító’.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A Játék időtartama
      </Typography>
      <Typography variant="body1" paragraph>
        A nyereményjáték 2025. március 25. napján 12 óra 15 perctől 2025.
        április 12. napján 23 óra 59 percig tart.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A Játékban részt vevő személyek
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékban 18. életévüket betöltött, cselekvőképességükben nem
        korlátozott természetes személyek vehetnek részt, a továbbiakban
        ‘Játékos’. A játékban kizárólag a Facebookon lehet részt venni.
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékban a Szervező tulajdonosai, vezető tisztségviselői,
        munkavállalói, a velük munkavégzésre irányuló jogviszonyban állók,
        egyéb, a lebonyolításban esetlegesen közvetlenül közreműködő cégek
        vezető tisztségviselői, munkavállalói, tulajdonosai, valamint mindezen
        személyek a Ptk. 8:1 § (1) bekezdésében meghatározott közeli
        hozzátartozói nem vehetnek részt.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A Játék menete és a részvétel feltétele
      </Typography>
      <Typography variant="body1" paragraph>
        A játék a www.facebook.com/birdsofparadisebuda hírfolyamában megosztott
        nyereményjáték-poszton keresztül érhető el, a játék időtartama alatt. A
        sorsolás eredményét a megadott Facebook oldalon hirdetjük ki.
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékban való részvétel feltétele, hogy a Játékos az adott poszt alá
        kommentben leírja, mi volt a legmeghatározóbb jógaélménye.
      </Typography>
      <Typography variant="body1" paragraph>
        Az adott Játékos kizárólag saját nevében vehet részt a Játékban.
        <br />A Játékos a Játékban való részvétellel elfogadja jelen
        játékszabályzatot és hozzájárul személyes adatai kezeléséhez a
        játékszabályzatban rögzített adatkezelési feltételekben foglaltaknak
        megfelelően.
      </Typography>
      <Typography variant="body1" paragraph>
        Nyertesség esetén a kapcsolatfelvételhez és a nyeremény átadásához
        szükséges adatok:
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">név</Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">e-mail cím</Typography>
        </ListItem>
      </List>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Nyeremények
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékban a Játék időtartama alatt a fenti feltételeknek megfelelően
        érvényesen résztvevő Játékosok között kisorsolásra kerül:
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">1 havi korlátlan jógabérlet</Typography>
        </ListItem>
      </List>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Nyertesek kiválasztása
      </Typography>
      <Typography variant="body1" paragraph>
        A sorsolás során a játékban résztvevők közül véletlenszerűen kerülnek
        kiválasztásra a nyertesek, amelyre 2025. április 13-án, 14:00 órakor a
        Lebonyolító székhelyén kerül sor. A nyereményjáték során 1 nyertest és 1
        tartaléknyertest sorsolunk ki.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A nyertesek értesítése
      </Typography>
      <Typography variant="body1" paragraph>
        A nyertes nevét a fent megnevezett Facebook oldal hírfolyamában tesszük
        közzé. A kihirdetést követően a nyertesnek 5 napon belül privát
        üzenetben kell felvennie a kapcsolatot a szervezőkkel a megadott
        Facebook oldalon. Ezt követően e-mailben visszaigazolást kap a
        nyereményről, amelyet az átvétel során be kell mutatnia.
      </Typography>
      <Typography variant="body1" paragraph>
        Egy-egy nyertes sikertelen értesítése esetén pótnyertes lép a helyébe. A
        Szervező és Lebonyolító fenntartja a jogot, hogy visszajelzés hiányában,
        a megadott határidőn túli jelentkezés esetén az adott nyeremény átadását
        sikertelennek minősítse.
        <br />A nyeremény pénzre nem váltható. A nyereményhez tartozó SZJA
        fizetési kötelezettség a Szervezőt terheli. A Szervezőt a nyeremény
        átadásán és adóvonzatuk kiegyenlítésén kívül további kötelezettség nem
        terheli.
      </Typography>
      <Typography variant="body1" paragraph>
        Mivel a játékban csak a 4. pontban írt feltételeknek megfelelő, érvényes
        e-mail címmel rendelkező személyek (Facebook profilok) vehetnek részt,
        így a Facebook profilhoz tartozó e-mail címen keresztül történő
        kapcsolatfelvételnél az e-mail cím szolgáltatóknál fellépő hibákért vagy
        kézbesíthetetlenségért a Szervező és a Lebonyolító felelősséget nem
        vállal. A Játékos téves adatszolgáltatásából eredően a Szervezőt és
        Lebonyolítót semmilyen felelősség nem terheli.
      </Typography>
      <Typography variant="body1" paragraph>
        A Szervező fenntartja a jogot, hogy kizárja minden jelenlegi és jövőben
        szervezett promóciójából azt, aki bármely, a Szervező által szervezett
        promócióban csalást/hamisítást követ el.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A nyeremények átadása
      </Typography>
      <Typography variant="body1" paragraph>
        A nyeremény a Birds of Paradise Jóga Stúdióban (1015 Budapest, Hattyú
        utca 14.) vehető át, a nyereményt megerősítő email bemutatásával.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Záró rendelkezések
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékot a Facebook (Meta) nem szponzorálja, nem támogatja és nem
        hozható semmilyen módon sem kapcsolatba vele. A Facebook (Meta) nem vesz
        részt a Játék szervezésében, ezért a Játékban való részvétellel
        kapcsolatban teljeskörűen és hiánytalanul mentesül a Játékból eredő
        bármiféle kötelezettség alól. A Játékos az adatait a Játék Szervezőjének
        és Lebonyolítójának bocsátja rendelkezésére, nem a Facebooknak. A
        Játékos által megadott információk csak a játékadminisztráció céljára
        kerülnek felhasználásra.
      </Typography>
      <Typography variant="body1" paragraph>
        A Szervező fenntartja a jogot, hogy a jelen Játékszabályzatban foglalt
        feltételeket vagy magát a nyereményjátékot a játék időtartama alatt
        módosítsa, vagy megszüntesse. A szabályzat módosítását, illetve a
        nyereményjáték esetleges megszüntetéséről szóló értesítést a Szervező
        közzéteszi a Birds of Paradise hivatalos Facebook oldalán. A
        nyereményjátékban résztvevők felelőssége, hogy ezekről megfelelően
        tájékozódjanak.
      </Typography>
      <Typography variant="body1" paragraph>
        Kelt: 2025. március 25.
        <br />
        Birds of Paradise Kft.
      </Typography>

      <Box my={6}>
        <Divider />
      </Box>

      <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
        Adatkezelési tájékoztató
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Adatkezelő megnevezése
      </Typography>
      <Typography variant="body1" paragraph>
        Cégnév: Birds of Paradise Korlátolt Felelősségű Társaság
        <br />
        Székhely: 1015 Budapest, Batthyány utca 48. 4. emelet 7.
        <br />
        Cégjegyzékszám: 01-09-378875
        <br />
        Adószám: 28846830-2-41
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Az adatkezelés alapjául szolgáló jogszabályok
      </Typography>
      <Typography variant="body1" paragraph>
        A születésnapi nyereményjáték során felmerülő adatkezelésekre az alábbi
        jogszabályok vonatkoznak:
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Az Európai Parlament és a Tanács (Eu) 2016/679 rendelete (2016.
            április 27.) a természetes személyeknek a személyes adatok kezelése
            tekintetében történő védelméről és az ilyen adatok szabad
            áramlásáról, valamint a 95/46/EK rendelet hatályon kívül
            helyezéséről, hatályos szövege:
            https://eur-lex.europa.eu/legal-content/HU/TXT/PDF/?uri=CELEX:32016R0679&from=HU
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az információs önrendelkezési jogról és az információszabadságról
            szóló 2011. évi CXII. törvény (a továbbiakban: Info tv.), hatályos
            szövege: https://net.jogtar.hu/jogszabaly?docid=A1100112.TV
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            a gazdasági reklámtevékenység alapvető feltételeiről és egyes
            korlátairól szóló 2008. évi XLVIII. törvény, hatályos szövege:
            https://net.jogtar.hu/jogszabaly?docid=A0800048.TV
          </Typography>
        </ListItem>
      </List>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        A kezelt adatokra vonatkozó információk
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        A kezelt adatok köre és az adatkezelés célja
      </Typography>
      <Typography variant="body1" paragraph>
        A kezelt adatok körét és célját, időtartamát, jogalapját és a kezelés
        módját jelen tájékoztató függeléke tartalmazza.
        <br />A Játékos a részvétellel elfogadja, hogy nyertessége esetén nevét
        a nyereményjátékkal összefüggésben az Birds of Paradise Kft. saját
        honlapján, valamint kommunikációs felületein megjelentetheti.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Az adatokhoz való hozzáférés és az adatbiztonsági intézkedések
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Az adatokhoz való hozzáférés és az adattovábbítás
      </Typography>
      <Typography variant="body1" paragraph>
        A Játékos által megadott személyes adatokhoz az Adatkezelő munkatársai
        férhetnek hozzá a feladataik ellátása érdekében.
        <br />
        Az Adatkezelő csak kivételes esetben adja át a személyes adatait más –
        jelen szabályzatban fel nem sorolt – Adatkezelőknek, állami szerveknek.
        <br />
        Így például, amennyiben:
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az Önt érintő ügyben bírósági eljárás indul, és az eljáró bíróság
            számára szükséges az Ön személyes adatait tartalmazó iratok átadása,
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            a rendőrség megkeresi az Adatkezelőt, és a nyomozáshoz az Ön
            személyes adatait tartalmazó iratok továbbítását kéri.
          </Typography>
        </ListItem>
      </List>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Adatbiztonsági intézkedések
      </Typography>
      <Typography variant="body1" paragraph>
        Az Adatkezelő az Ön által megadott személyes adatokat az Adatkezelő
        szerverén, illetve adott esetben papír alapú irattárában tárolja.
        <br />A személyes adatok tárolásához az Adatkezelő más cég
        szolgáltatásait nem veszi igénybe. Adatkezelő megfelelő intézkedésekkel
        gondoskodik arról, hogy a személyes adatokat védje többek között a
        jogosulatlan hozzáférés ellen vagy azok jogosulatlan megváltoztatása
        ellen. Így például a szerveren tárolt személyes adatokhoz való
        hozzáférést Adatkezelő naplózza, vagyis mindig ellenőrizhető, ki, mikor,
        milyen személyes adatokhoz fért hozzá.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Az érintett adatkezeléssel kapcsolatos jogai
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Az Ön hozzáférési jogai
      </Typography>
      <Typography variant="body1" paragraph>
        Ön, mint jogosult hozzáférhet a személyes adataihoz.
        <br />
        Ha azt kéri, hogy az Adatkezelő visszajelzést adjon arra vonatkozóan,
        hogy kezeli-e a személyes adatait, az Adatkezelő köteles tájékoztatást
        adni, az alábbiakra vonatkozóan:
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">milyen személyes adatait,</Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">milyen jogalapon,</Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            milyen adatkezelési cél miatt,
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">milyen forrásból,</Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">mennyi ideig kezeli.</Typography>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Az Ön azon joga, hogy visszajelzést kapjon arról, hogy az Adatkezelő
        kezeli-e (vagy sem) a személyes adatait, az Önre vonatkozó személyes
        adatokra terjed ki;
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            nem terjed ki az anonim adatokra;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            nem terjed ki a nem Önre vonatkozó személyes adatokra; és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            magában foglalja az egyértelműen az Önhöz kapcsolható álnevesített
            adatokat.
          </Typography>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Az Adatkezelő az Ön kérésére hozzáférést és másolatot biztosít a
        személyes adataihoz. Ha Ön további/ismételt másolatot kér a személyes
        adatairól, az Adatkezelő észszerű díjat számíthat fel a kérés
        teljesítésével összefüggésben felmerülő adminisztratív költségek
        megtérítésére, mely díjat Ön fog viselni.
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Az Ön helyesbítéshez való joga
      </Typography>
      <Typography variant="body1" paragraph>
        Ön jogosult a személyes adatai helyesbítésére.
      </Typography>
      <Typography variant="body1" paragraph>
        E joga
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            nem terjed ki az anonim adatokra;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az Önre vonatkozó személyes adatokra terjed ki;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            nem terjed ki a nem Önre vonatkozó személyes adatokra; és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            magában foglalja az egyértelműen Önhöz kapcsolható álnevesített
            adatokat.
          </Typography>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Az Adatkezelő az Ön kérése alapján megfelelően javítja vagy kiegészíti
        személyes adatait. Az Adatkezelő az Ön személyes adatainak
        helyesbítéséről tájékoztatja a személyes adatok címzettjeit (ha vannak
        ilyenek). Az Adatkezelő azonban nem tájékoztatja a címzetteket a
        személyes adatok helyesbítéséről, ha a címzettek tájékoztatása
        lehetetlennek bizonyul vagy aránytalanul nagy erőfeszítést igényelne.
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Törléshez való jog
      </Typography>
      <Typography variant="body1" paragraph>
        Bizonyos feltételek esetén Ön jogosult a személyes adatai törlésére.
        <br />A résztvevő tudomásul veszi, hogy a Játékból való kizáráshoz
        vezet, ha a Játék lebonyolításához szükséges adatok törlését a
        Játékszabályzat 6. pontjában megjelölt nyeremények átadása előtt
        kérelmezi.
      </Typography>
      <Typography variant="body1" paragraph>
        Az Adatkezelő indokolatlan késedelem nélkül köteles törölni az Ön
        személyes adatait, amennyiben
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az Adatkezelő kezeli e személyes adatokat, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön a személyes adatai törlését kéri, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            a személyes adatok nem szükségesek azon célokra, amelyekre az
            Adatkezelő a személyes adatokat kezeli.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Az Adatkezelő indokolatlan késedelem nélkül köteles törölni az Ön
        személyes adatait, ha
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az Adatkezelő kezeli az Ön személyes adatait, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön a személyes adatai törlését kéri, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön visszavonja a hozzájárulását, amin az adatainak kezelése alapul,
            és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            nincs más jogalap az Ön adatainak további kezelésére.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Az Adatkezelő indokolatlan késedelem nélkül köteles törölni az Ön
        személyes adatait, ha
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az adatkezelés az Adatkezelő vagy egy harmadik fél jogos érdekeinek
            érvényesítéséhez szükséges, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön tiltakozik az ellen, hogy az Adatkezelő kezeli a személyes
            adatait, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az ilyen személyes adatok kezelését megalapozó jogszerű ok nem élvez
            elsőbbséget az Ön tiltakozásával szemben.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Az Adatkezelő indokolatlan késedelem nélkül köteles törölni az Ön
        személyes adatait, ha
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön a személyes adatai törlését kéri, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az ilyen adatok Adatkezelő általi kezelése nem jogellenes, vagy
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            a törlés kötelező a hatályos törvények értelmében, vagy
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            az Ön adatait az információs társadalommal összefüggő szolgáltatások
            vonatkozásában gyűjtik.
          </Typography>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Az Adatkezelő az Ön személyes adatainak törléséről tájékoztatja a
        személyes adatok címzettjeit (ha vannak ilyenek). Az Adatkezelő azonban
        nem tájékoztatja a címzetteket a személyes adatok törléséről, ha a
        címzettek tájékoztatása lehetetlen vagy aránytalanul nagy erőfeszítést
        igényelne.
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontStyle: "italic", marginTop: "16px" }}
        gutterBottom
      >
        Az Ön joga az adatkezelés korlátozásához
      </Typography>
      <Typography variant="body1" paragraph>
        Ön kérheti a személyes adatai kezelésének korlátozását.
        <br />
        Az Ön joga a személyes adatai kezelése korlátozásának kérése
        vonatkozásában
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (a) nem terjed ki az anonim adatokra;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (b) az Önre vonatkozó személyes adatokra terjed ki;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (c) nem terjed ki a nem Önre vonatkozó személyes adatokra; és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (d) magában foglalja az egyértelműen az Önhöz kapcsolható
            álnevesített adatokat.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Az Adatkezelő korlátozza az Ön személyes adatainak kezelését arra az
        időszakra, amely alatt ellenőrzi az ilyen adatok pontosságát, ha Ön a
        személyes adatai kezelésének korlátozását kéri és Ön vitatja az ilyen
        adatok pontosságát.
      </Typography>

      <Typography variant="body1" paragraph>
        Az Adatkezelő korlátozza az Ön személyes adatainak kezelését, ha Ön
        olyan adatok kezelésének korlátozását kéri, amelyek kezelése jogellenes,
        és Ön ellenzi az ilyen adatok törlését.
      </Typography>

      <Typography variant="body1" paragraph>
        Az Adatkezelő korlátozza az Ön személyes adatainak kezelését, ha
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (a) Ön a személyes adatai kezelésének korlátozását kéri, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (b) az Adatkezelőnek már nincs szüksége ezekre az adatokra az
            adatkezelése céljából, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (c) Ön az adatait jogi igény előterjesztéséhez, érvényesítéséhez
            vagy védelméhez igényli.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Az Adatkezelő korlátozza az Ön személyes adatainak kezelését, ha
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön tiltakozik az olyan személyes adatai kezelése ellen, amik
            szükségesek az Adatkezelő jogos érdekei céljából, és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Ön annak visszaigazolására vár, hogy az Ön személyes adatainak az
            Adatkezelő általi kezelésére van jogszerű ok, amely nem élvez
            elsőbbséget az Ön tiltakozásával szemben.
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            Az Adatkezelő az Ön személyes adatai kezelésének korlátozásáról
            tájékoztatja az ilyen személyes adatok címzettjeit (ha vannak
            ilyenek). Az Adatkezelő azonban nem tájékoztatja a címzetteket az
            ilyen korlátozásról, ha a címzettek tájékoztatása lehetetlen vagy
            aránytalanul nagy erőfeszítést igényelne.
          </Typography>
        </ListItem>
      </List>

      <Typography variant="body1" paragraph>
        Ha az Adatkezelő korlátozza az Ön személyes adatainak kezelését, akkor
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (a) tárolhatja az ilyen személyes adatokat,
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (b) az Ön hozzájárulása alapján kezelheti az ilyen személyes
            adatokat,
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (c) kezelheti a személyes adatokat jogi igényének előterjesztéséhez,
            érvényesítéséhez vagy védelméhez vagy valamely személy jogainak
            megvédéséhez.
          </Typography>
        </ListItem>
      </List>

      <Typography
        variant="subtitle1"
        style={{ fontWeight: "bold", marginTop: "16px" }}
        gutterBottom
      >
        Adathordozhatósághoz való joga
      </Typography>
      <Typography variant="body1" paragraph>
        Ön jogosult arra, hogy az Önre vonatkozó, Ön által egy adatkezelő
        rendelkezésére bocsátott személyes adatait tagolt, széles körben
        használt, géppel olvasható formátumban megkapja, továbbá jogosult arra,
        hogy ezeket az adatokat egy másik adatkezelőnek továbbítsák anélkül,
        hogy ez akadályozná (ahol technikailag lehetséges) azt az adatkezelőt,
        amelynek a személyes adatokat a rendelkezésére bocsátotta, ha az
        adatkezelés hozzájáruláson alapul vagy szerződés teljesítéséhez
        szükséges és az adatkezelés automatizált módon történik.
      </Typography>

      <Typography variant="body1" paragraph>
        Az Ön adathordozhatósághoz való joga
      </Typography>
      <List style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (a) nem terjed ki az anonim adatokra;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (b) az Önre vonatkozó személyes adatokra terjed ki;
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (c) nem terjed ki a nem Önre vonatkozó személyes adatokra; és
          </Typography>
        </ListItem>
        <ListItem style={{ display: "list-item" }}>
          <Typography variant="body1">
            (d) nem terjed ki az egyértelműen álnevesített adatokra.
          </Typography>
        </ListItem>
      </List>

      <Typography
        variant="subtitle1"
        style={{ fontWeight: "bold", marginTop: "16px" }}
        gutterBottom
      >
        Az Ön, mint érintett kérelmének ügyintézési határideje
      </Typography>
      <Typography variant="body1" paragraph>
        Az Adatkezelő az Önt a fentiek szerint megillető jogosultságokra
        vonatkozó kérelmekre indokolatlan késedelem nélkül, de legkésőbb egy
        hónapon belül válaszol.
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontWeight: "bold", marginTop: "16px" }}
        gutterBottom
      >
        Panasz benyújtásához való jog
      </Typography>
      <Typography variant="body1" paragraph>
        Ha Ön úgy véli, hogy a jogait megsértették, az Adatkezelő azt javasolja,
        hogy kezdeményezzen egyeztetést az Adatkezelővel közvetlen
        kapcsolatfelvétel útján. Ha az ilyen egyeztetés nem vezet eredményre,
        vagy ha Ön nem kíván részt venni ilyen tevékenységben, a bírósághoz vagy
        a NAIH-hoz fordulhat. Bírósági eljárás kezdeményezése esetén dönthet
        úgy, hogy az eljárást a lakcíme vagy lakóhelye szerinti illetékes
        bíróság előtt indítja meg.
      </Typography>
      <Typography variant="body1" paragraph>
        A NAIH kapcsolati adatai a következők: 1125 Budapest, Szilágyi Erzsébet
        fasor 22/C.; telefon: +36 1 391 1400; fax: +36 1 391 1410; e-mail:
        ugyfelszolgalat@naih.hu; weboldal: www.naih.hu
      </Typography>

      <Typography
        variant="subtitle1"
        style={{ fontWeight: "bold", marginTop: "16px" }}
        gutterBottom
      >
        A jelen tájékoztató módosításai
      </Typography>
      <Typography variant="body1" paragraph>
        Az Adatkezelő fenntartja a jogot, hogy bármikor módosítsa a jelen
        tájékoztatót. Az Adatkezelő adott esetben levélben vagy e-mailben és
        minden esetben a vonatkozó jogszabályok szerint tájékoztatja az
        Ügyfeleket az ilyen módosításokról.
      </Typography>

      <Typography variant="body1" paragraph>
        Kelt: 2025. március 25.
        <br />
        Birds of Paradise Kft.
      </Typography>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Függelék
      </Typography>

      <TableContainer component={Paper} style={{ marginBottom: "2rem" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Adat</b>
              </TableCell>
              <TableCell>
                <b>Milyen feladathoz / folyamathoz kerül felhasználásra</b>
              </TableCell>
              <TableCell>
                <b>Milyen jogalapon kerül felhasználásra</b>
              </TableCell>
              <TableCell>
                <b>Személyes adatok címzettjei</b>
              </TableCell>
              <TableCell>
                <b>Tárolás módja papíron és/vagy elektronikusan</b>
              </TableCell>
              <TableCell>
                <b>Tárolás helye</b>
              </TableCell>
              <TableCell>
                <b>Meddig szükséges tárolni az adatokat</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <b>Név</b>
              </TableCell>
              <TableCell>Nyereményjátékban való részvétel</TableCell>
              <TableCell>Hozzájárulás</TableCell>
              <TableCell>
                Jogosult munkatársak, marketinggel megbízott munkatársak
              </TableCell>
              <TableCell>Elektronikus</TableCell>
              <TableCell>Facebook, 1015 Budapest, Hattyú utca 14.</TableCell>
              <TableCell>Cél teljesüléséig</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <b>E-mail cím</b>
              </TableCell>
              <TableCell>Nyereményjátékban való részvétel</TableCell>
              <TableCell>Hozzájárulás</TableCell>
              <TableCell>
                Jogosult munkatársak, marketinggel megbízott munkatársak
              </TableCell>
              <TableCell>Elektronikus</TableCell>
              <TableCell>Facebook, 1015 Budapest, Hattyú utca 14.</TableCell>
              <TableCell>Cél teljesüléséig</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" fontWeight="bold" mt={4} gutterBottom>
        Adattovábbítások nyilvántartása
      </Typography>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Dátum</b>
              </TableCell>
              <TableCell>
                <b>Címzett</b>
              </TableCell>
              <TableCell>
                <b>Személyes adatok köre</b>
              </TableCell>
              <TableCell>
                <b>Egyéb adatok</b>
              </TableCell>
              <TableCell>
                <b>Megjegyzés</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Nyereményjáték lebonyolításáig</TableCell>
              <TableCell>Green Edge Media Group Kft., Lebonyolító</TableCell>
              <TableCell>Függelék alapján</TableCell>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RulesContent;
